//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import debounce from 'debounce';
import { ROWS_ITEMS } from '~/constants.js';
import { onlyNumbersMixin } from '~/mixins';

export default {
    mixins: [onlyNumbersMixin],
    props: {
        totalPages: { type: Number, default: 1 }
    },
    data: function data() {
        var pageNumber = 1;

        return {
            pageSize: ROWS_ITEMS[0],
            pageNumber: pageNumber,
            pageNumberInputValue: pageNumber,
            rows: ROWS_ITEMS
        };
    },

    computed: {
        pageAllLeftDisabled: function pageAllLeftDisabled() {
            return this.pageNumber === 1;
        },
        pageAllRightDisabled: function pageAllRightDisabled() {
            return this.pageNumber >= this.totalPages;
        }
    },
    watch: {
        totalPages: function totalPages(val) {
            this.updateMaxValueOnPageNumberInput();
        },
        pageSize: function pageSize(val) {
            if (this.pageNumber !== 1) {
                this.pageNumber = 1;
            }
        }
    },
    methods: {
        updateMaxValueOnPageNumberInput: function updateMaxValueOnPageNumberInput() {
            if (!this.$refs.pageNumberInput) return;

            var input = this.$refs.pageNumberInput.$el.querySelector('input');
            input.setAttribute('min', '1');
            input.setAttribute('max', this.totalPages.toString());
        },

        manualChangePage: debounce(function (val) {
            this.emit();
            if (this.pageNumber == 0 || this.pageNumber == '') {
                this.pageNumber = 1;
            } else if (this.pageNumber > this.totalPages) {
                this.pageNumber = this.totalPages;
            }
        }),
        allLeft: function allLeft() {
            this.pageNumber = 1;
            this.emit();
        },
        allRight: function allRight() {
            this.pageNumber = this.totalPages;
            this.emit();
        },
        emit: function emit() {
            this.$nextTick(function () {
                this.$emit('input', { pageNumber: this.pageNumber, pageSize: this.pageSize });
            });
        }
    },
    mounted: function mounted() {
        this.updateMaxValueOnPageNumberInput();
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/pagination-box.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/pagination-box.vue
// module chunks = 34